<template>
  <div class="xqleft">
    <div class="chengshi">
      <div>{{ jzxq.name }}</div>
      <div style="font-size:14px"><img src="@/assets/dw.png" style="margin-right:10px">{{ jzxq.cityName }}</div>
    </div>
    <div class="llist">
      <ul>

        <li style="width: 100%">
          <h1 class="mingcheng">电池配置</h1>
          <h2 class="shuzhi ">{{ jzxq.battery_config }}</h2>
        </li>
        <li>
          <h1 class="mingcheng">负载大小</h1>
          <h2 class="shuzhi ">{{ jzxq.stationLoad }}<span class="danwei">KW</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">入网时间</h1>
          <h2 class="shuzhi ">56<span class="danwei">天</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">最低备电时长1</h1>
          <h2 class="shuzhi ">{{ jzxq.slaveLowestTime }}<span class="danwei">小时</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">最低备电时长2</h1>
          <h2 class="shuzhi ">456<span class="danwei">小时</span></h2>
        </li>

        <li>
          <h1 class="mingcheng">开关电源厂家</h1>
          <h2 class="shuzhi">{{ jzxq.switchFactory }}</h2>
        </li>

        <li>
          <h1 class="mingcheng">电池厂家</h1>
          <h2 class="shuzhi">{{ jzxq.batteryFactory }}</h2>
        </li>
        <li>
          <h1 class="mingcheng">当前可充电总量</h1>
          <h2 class="shuzhi ">{{ jzxq.allow_charge_total }}<span class="danwei">kw/h</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">当前可放电总量</h1>
          <h2 class="shuzhi ">{{ jzxq.allow_discharge_total }}<span class="danwei">kw/h</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">当日节省电费</h1>
          <h2 class="shuzhi ">{{ jzxq.today_power_rate_save }}<span class="danwei">元</span></h2>
        </li>
        <li>
          <h1 class="mingcheng">当月节省电费</h1>
          <h2 class="shuzhi ">{{ jzxq.month_power_rate_save }}<span class="danwei">元</span></h2>
        </li>
      </ul>
    </div>
    <div class="quxian">
      近6个月电费曲线
    </div>
    <v-chart class="chart" :option="options" :autoresize="true" />

  </div>
</template>

<script>
import { defineComponent, ref, onMounted, watch } from "vue";
//import * as echarts from 'echarts';

export default defineComponent({
  components: {

  },
  props: { jzxq: Object, chatdata: Object },
  setup(props) {


    const options = ref({
      grid: {
        top: "8%",
        right: "6%",
        left: "16%",
        bottom: "18%",
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
      },
      xAxis: {
        type: "category",
        boundaryGap: false, // 紧挨边缘
        axisTick: {
          // x轴上的小刻度
          show: false,
        },
        axisLabel: {
          // x轴样式
          margin: 15, // x轴距离文字距离
          color: "#b2bacc",
        },
        data: [],
      },
      yAxis: {
        //name: '元',
        type: "value",
        // min: 0, // 设置y轴刻度的最小值
        // max: 1800, // 设置y轴刻度的最大值
        splitNumber: 5, // 设置y轴刻度间隔个数
        splitLine: {
          // 网格线
          show: true,
          lineStyle: {
            type: "dotted", // dotted 虚线 solid 实线
            color: "rgba(255, 255, 255,0.3)",
          },
        },
        axisLabel: {
          //y 轴样式
          formatter: "{value}元",
          color: "#A1A7B3",
          fontSize: 12,
        },
      },
      series: [
        {
          data: [],
          type: "line",
          smooth: true, // 平滑过渡
          symbol: "none", // 拐点设置为实心圆点 默认是空心圆点 ECharts 提供的标记类型包括 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none' 可以通过 'image://url' 设置为图片，其中 URL 为图片的链接
          // symbolSize: 8, // 拐点圆的大小
          lineStyle: {
            //线条样式
            width: 2,
            color: "#2489ff",
            type: "solid", //虚线  dotted 点线 solid 实线 dashed 虚线
          },
          //填充风格
          areaStyle: {
            color: "rgba(10, 29, 55, 0.8)",
          },
        },
      ],
    });


    const getData = () => {


    };

    watch(props, () => {

      props.chatdata.some((item) => {
        options.value.series[0].data.push(item.powerRateTotal)
        options.value.xAxis.data.push(item.currentMonth + '月')

      })
    }, {
      deep: true
    });

    onMounted(() => {
      //组件挂载时的生命周期执行的方法
      getData()
    });

    return {
      options, getData
    };
  },
});
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.xqleft {

  height: 100%;
  background: url("@/assets/bjk2.png");
  background-size: 100% 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  padding-bottom: 30px
}

.chengshi {
  padding-top: 36px;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 16px;
  font-weight: bold;
  justify-content: space-between;
  background: url("@/assets/xian2.png") no-repeat bottom center;
  padding-bottom: 10px;

}

.quxian {
  background: url("@/assets/biaoti.png") no-repeat;
  font-size: 14px;
  color: #fff;
  font-weight: bold;
  margin-left: 20px;
  padding-left: 20px;
  margin-right: 20px;
}

.llist {
  padding: 20px 20px 0;
}

.llist ul li {
  float: left;
  list-style: none;
  width: 100%;
  color: #fff;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between
}

.mingcheng {
  color: #c0c3c9;
  font-size: 15px;
  padding: 0;
  margin: 0;
}

.shuzhi {
  color: #2489ff;
  font-size: 18px;
  padding: 0;
  margin: 0;
  font-weight: bold;
}

.fxnum {
  font-size: 24px;
  font-family: "denmark";
}

.danwei {
  color: #2489ff;
  font-size: 12px;
  padding-left: 5px;
  font-weight: bold;
}
</style>
